import { important } from 'csx';
import { TEAL_PRIMARY } from 'src/common-ui/theme';
import { style } from 'typestyle';

export const COLLCARD_WIDTH = 560;
export const COLLCARD_HEIGHT = 515;
export const HEADER_HEIGHT = 70;
// I don't know why the width has to be so wide, but if I don't
// do it this way, the image won't size to its needed width.
export const ANCHOR_IMG_W = 200;
export const ANCHOR_IMG_H = 130;
export const ITEM_THUMB_SIZE = 100;

const card = style({
  $debugName: 'collectionCard-card',
  height: '95%',
  width: '100%',
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  background: '#f5f5f5',
  border: '1px solid transparent',
  breakInside: 'avoid',
  pageBreakInside: 'avoid',
});

const header = style({
  $debugName: 'collectionCard-header',
  background: `linear-gradient(135deg, ${TEAL_PRIMARY}, #0084a8ff)`,
  height: HEADER_HEIGHT,
  // This allows fitting the collection type and subtitle in the title section
  paddingTop: 7,
  paddingBottom: 3,
  paddingLeft: 10,
  color: 'white',
  flexShrink: 0,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
});

const headerTitle = style({
  $debugName: 'collectionCard-headerTitle',
  fontWeight: 700,
  fontSize: '1.1rem',
  margin: 0,
  display: 'flex'
});

const headerSubTitle = style({
  $debugName: 'collectionCard-subTitle',
  display: 'flex',
  flexDirection: 'row',
  gap: 5,
  alignItems: 'center',
})

const headerDesc = style({
  $debugName: 'collectionCard-headerDesc',
  fontSize: '0.8rem',
  marginTop: 4,
  opacity: 0.9,
  overflow: 'hidden',
});

const headerId = style({
  $debugName: 'collectionCard-headerId',
  fontSize: '0.7rem',
  marginTop: 4,
  opacity: 0.7,
  display: 'block',
});

const sectionLabel = style({
  $debugName: 'collectionCard-sectionLabel',
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  fontSize: '0.65rem',
  fontWeight: 700,
  color: '#888',
  padding: '8px 14px 4px',
});

const anchorSubCard = style({
  $debugName: 'collectionCard-anchorSubCard',
  display: 'flex',
  alignItems: 'center',
  // maxWidth: '80%',
  marginLeft: '1rem'
});

const anchorImage = style({
  $debugName: 'collectionCard-anchorImage',
  width: ANCHOR_IMG_W,
  height: ANCHOR_IMG_H,
  objectFit: 'cover',
  borderRadius: 6,
});

const anchorInfo = style({
  $debugName: 'collectionCard-anchorInfo',
  marginLeft: 12,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const anchorName = style({
  $debugName: 'collectionCard-anchorName',
  fontWeight: 700,
  fontSize: '0.85rem',
});

const anchorCategory = style({
  $debugName: 'collectionCard-anchorCategory',
  fontSize: '0.75rem',
  color: '#555',
});

const anchorBadge = style({
  $debugName: 'collectionCard-anchorBadge',
  display: 'inline-block',
  background: '#E8A020 !important',
  color: 'white',
  fontSize: '0.6rem !important',
  fontWeight: '700 !important',
  marginTop: 6,
  letterSpacing: '0.05em',
  $nest: {
    '>span': {
      padding: 10,
    },
  },
});

const itemsSection = style({
  $debugName: 'collectionCard-itemsSection',
  padding: '4px 10px 10px',
});

const itemsRow = style({
  $debugName: 'collectionCard-itemsRow',
  display: 'flex',
  flexDirection: 'row',
  $nest: {
    // These two things replace justify-content: center
    // so that cards don't get hidden to left/right in overflow
    // ...yes it's weird
    // '&::before,&::after': {
    //   content: "''",
    //   width: '100%',
    // },
    // '> div': {
    //   flexGrow: 1
    // }
  },
  gap: 8,
  flexWrap: 'nowrap',
  overflowX: 'auto',
});

const itemCard = style({
  $debugName: 'collectionCard-itemCard',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: ITEM_THUMB_SIZE,
  flexShrink: 0,
  marginBottom: '1.5rem'
});

const itemImageContainer = style({
  $debugName: 'collectionCard-itemImageContainer',
  width: ITEM_THUMB_SIZE,
  height: ITEM_THUMB_SIZE,
  background: '#f0f0f0',
  borderRadius: 8,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const itemCategory = style({
  $debugName: 'collectionCard-itemCategory',
  fontSize: '0.6rem',
  fontWeight: 700,
  color: '#4A6FA5',
  textTransform: 'uppercase',
  marginTop: 4,
  textAlign: 'center',
});

const itemName = style({
  $debugName: 'collectionCard-itemName',
  fontSize: '0.65rem',
  textAlign: 'center',
  color: '#333',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: ITEM_THUMB_SIZE,
  // word wrap handling
  // This allows us to set the number of lines in word wrap scenarios
  wordWrap: 'normal',
  display: '-webkit-box',
  '-webkit-line-clamp': 2,
  //@ts-ignore:next-line
  '-webkit-box-orient': 'vertical',
  // this is the safety fallback if box-orient isn't browser available
  maxHeight: '2rem',
});

const linkButton = style({
  $debugName: 'collectionCard-linkButton',
  // background: TEAL_PRIMARY,
  color: TEAL_PRIMARY,
  padding: '4px 10px',
  fontSize: '0.8rem',
  cursor: 'pointer',
  letterSpacing: '0.03em',
  whiteSpace: 'nowrap',
  $nest: {
    '&:hover': {
      opacity: 0.85,
    },
  },
});
const cardOverlay = style({
  $debugName: 'collectionCard-cardOverlay',
  position: 'absolute',
  width: '100%',
  height: '100%',
  background: 'white',
  opacity: 0.4,
  zIndex: 1,
  pointerEvents: 'none',
});

const iconOverlay = style({
  $debugName: 'collectionCard-iconOverlay',
  position: 'absolute',
  fontSize: '3rem',
  color: TEAL_PRIMARY,
  top: '47%',
  left: '43%',
  zIndex: 2,
  background: 'white',
  borderRadius: 60,
});
export default {
  card,
  header,
  headerTitle,
  headerSubTitle,
  headerDesc,
  headerId,
  sectionLabel,
  anchorSubCard,
  anchorImage,
  anchorInfo,
  anchorName,
  anchorCategory,
  anchorBadge,
  itemsSection,
  itemsRow,
  itemCard,
  itemImageContainer,
  itemCategory,
  itemName,
  linkButton,
  cardOverlay,
  iconOverlay
};
